//
// Repeat Gift Select
//
// Manages days_of_month field for recurring gifts
//
// Days o
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'input',
    'summary',
    'summaryEdit', // edit button
    'dayOptionContent',
    'dayOption',
    'periodOption',
  ]
  static values = {
    period: String, // once, monthly,
    days: String // '0', '1', '5,20', 'Wednesday'
  }

  connect() {
    if (!this.hasInputTarget) {
      console.log('missing repeat select input target')
    }
    this.daysValue = this.inputTarget.value

    this.enableSelect()
    this.render()
  }

  enableSelect() {
    this.periodOptionTargets.forEach((option) => option.removeAttribute('disabled'))
  }

  changePeriod(event) {
    this.periodValue = event.target.value

    // set selected state of event target
    // remove selected from everything else
    this.periodOptionTargets.forEach((option) => {
      if (option.value === this.periodValue) {
        option.classList.add('selected')
      } else {
        option.classList.remove('selected')
      }
    })

    this.changeDays()
    this.render()
  }

  changeDays() {
    const nextDaysOfMonth = []

    this.dayOptionTargets.forEach((option) => {
      const optionPeriod = option.dataset.period

      if (optionPeriod !== this.periodValue) {
        return
      }
      option.querySelectorAll('select').forEach((daySelect) => {
        nextDaysOfMonth.push(daySelect.value)
      })
    })

    // Prevent the same date from being selected twice
    if (this.periodValue == 'bimonthly') {
      const bimonthly1 = document.querySelector("[name='day[bimonthly][0]']")
      const bimonthly2 = document.querySelector("[name='day[bimonthly][1]']")
      disableSelectOption(bimonthly1, bimonthly2.value)
      disableSelectOption(bimonthly2, bimonthly1.value)
    }

    if (this.periodValue === 'once') {
      this.daysValue = '0'
    } else {
      this.daysValue = nextDaysOfMonth.join(',')
    }
    this.render()
  }

  hide(el) {
    el.classList.add('d-none')
  }

  show(el) {
    el.classList.remove('d-none')
  }

  // Action
  open() {
    this.show(this.dayOptionContentTarget)
  }

  // Public. Action
  close() {
    this.hide(this.dayOptionContentTarget)
  }

  renderSummary() {
    let summaryText, days, editable=true
    switch (this.periodValue) {
      case 'once':
        summaryText = 'We will charge you <strong>one time</strong> and process your gift instantly.'
        editable=false

        break
      case 'monthly':
        summaryText = `We will charge you on the <strong>${ordinalize(
          this.daysValue
        )}</strong> of every month.`
        break
      case 'bimonthly':
        days = this.daysValue.split(',')
        summaryText = `We will charge you on the <strong>${ordinalize(
          days[0]
        )}</strong> and the <strong>${ordinalize(
          days[1]
        )}</strong> of every month.`
        break
      case 'weekly':
        summaryText = `We will charge you every ${this.daysValue}.`
        break
      default:
        return
    }
    this.summaryTarget.innerHTML = summaryText
    editable ? this.show(this.summaryEditTarget) : this.hide(this.summaryEditTarget) 
  }

  renderDaySelects() {
    const period = this.periodValue

    if (period == 'once') {
      this.hide(this.dayOptionContentTarget)
    } else {
      this.show(this.dayOptionContentTarget)
      this.dayOptionTargets.forEach((option) => {
        const optionPeriod = option.getAttribute('data-period')
        if (optionPeriod !== period) {
          this.hide(option)
          return
        }
        this.show(option)
      })
    }
  }

  render() {
    this.renderDaySelects()
    this.renderSummary()
    this.inputTarget.value = this.daysValue
  }
}

//
// getPeriodFromDaysOfMonth(daysOfMonth: string)
//
// Example Values: days_of_month
// '1' // monthly
// '5,20', // bimonthly
// 'Wednesday' // weekly
// '0' // once
function getPeriodFromDaysOfMonth(daysOfMonth) {
  if (isWeeklyPeriod(daysOfMonth)) {
    return 'weekly'
  } else if (isMonthlyPeriod(daysOfMonth)) {
    return 'monthly'
  } else if (isBimonthlyPeriod(daysOfMonth)) {
    return 'bimonthly'
  } else if (isOncePeriod(daysOfMonth)) {
    return 'once'
  } else {
    // error
  }
}

function isMonthlyPeriod(daysOfMonth) {
  // (1..31).include?(days_of_month[0].to_i)
}
function isWeeklyPeriod(daysOfMonth) {
  const matcher = /^Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday$/i
  if (daysOfMonth.match(matcher)) {
    return true
  }
  return false
}

function isBimonthlyPeriod(daysOfMonth) {
  if (daysOfMonth.size == 2) {
    return true
  }
  return false
}

function isOncePeriod(daysOfMonth) {
  return daysOfMonth == [0]
}

function disableSelectOption(select, value) {
  const options = select.querySelectorAll('option')
  options.forEach((option) => {
    option.value == value ? (option.disabled = true) : (option.disabled = false)
  })
}

function ordinalize(n) {
  var s = ['th', 'st', 'nd', 'rd'],
    v = n % 100

  return n + (s[(v - 20) % 10] || s[v] || s[0])
}

